import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./callout.css.ts.vanilla.css-mistica.js";
var y = "_14g0jmy1 _1y2v1nf6e _1y2v1nf7n _1y2v1nf8w _1y2v1nfa5 _1y2v1nfb5 _1y2v1nfdw _1y2v1nfe5", _ = "_14g0jmy3 _1y2v1nfbr";
export { y as container, _ as content };
